
export const AgentHasPermissionProjectAdmin = (agentInfo) => {
  if (agentInfo == null) {
    return false;
  }

  if (agentInfo["permission"] & 0x0001) { 
      return true;
  }

  return false;
}

export const AgentHasPermissionCustomerAdmin = (agentInfo) => {
  if (agentInfo == null) {
    return false;
  }

  if (AgentHasPermissionProjectAdmin(agentInfo)) {
    return true;
  }

  if (agentInfo["permission"] & 0x0020) {
    return true;
  }

  return false;
}

export const AgentHasPermissionCustomerManager = (agentInfo) => {
  if (agentInfo == null) {
    return false;
  }

  if (AgentHasPermissionCustomerAdmin(agentInfo)) {
    return true;
  }

  if (agentInfo["permission"] & 0x0040) {
    return true;
  }

  return false;
}

export const AgentHasPermissionCustomerAgent = (agentInfo) => {
  if (agentInfo == null) {
    return false;
  }

  if (AgentHasPermissionCustomerManager(agentInfo)) {
    return true;
  }

  if (agentInfo["permission"] & 0x0010) {
    return true;
  }

  return false;
}
